module.exports = __webpack_public_path__ + "img/drug_enforcement-hotspot-3.2.375077b6.png";